import { Types } from '../actionTypes'

const initialClockSkew = {
  skewed: false,
  offsetMismatch: false,
  serverTime: null,
  localTime: null,
}

const initialState = {
  isOnline: true,
  update: false,
  cameras: [],
  clockSkew: initialClockSkew,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_IS_ONLINE:
      return {
        ...state,
        isOnline: action.payload
      }
    case Types.SET_CLOCK_SKEW:
      return {
        ...state,
        clockSkew: {
          ...initialClockSkew,
          ...action.payload,
        }
      }
    case Types.SET_CAMERAS:
      return {
        ...state,
        cameras: action.payload
      }
    case Types.SET_UPDATE:
      return {
        ...state,
        update: action.payload
      }
    case Types.CLEAN_AUTH:
      return initialState
    default:
      return state
  }
}

export default reducer